import { RegionId } from '../region-id.enum';
import { StripeProductType } from '../stripe-product-type';
import { RequiredDesignFileTemplateBody } from './required-design-file-template-body.model';

/**
 * Body for POST/PUT /api/required-design-file-templates.
 *
 * Create may include isActive. Update keeps active managed by PATCH /active.
 */
export interface RequiredDesignFileTemplateRequest {
    readonly name: string;
    readonly isActive?: boolean | null;
    readonly treatmentTypeOriginalId?: number | null;
    readonly treatmentSubTypeOriginalId?: number | null;
    readonly organizationId?: string | null;
    readonly officeId?: string | null;
    readonly region?: RegionId | null;
    readonly stripeProductType?: StripeProductType | null;
    readonly body: RequiredDesignFileTemplateBody;
}
